module.exports = __webpack_public_path__ + "static/media/ps-logo.a7b19a31.png";